import { Logger } from '@synisys/skynet-store-utilities';
import { attempt, isError, isNil } from 'lodash';
import { DynamicLayoutType } from './dynamic-layout';
import { ValidationDisplayType, } from '@synisys/idm-validation-calculation-service-client-js';
export function isJson(str) {
    return !isError(attempt(JSON.parse, str));
}
export function isBooleanString(str) {
    return str === 'true' || str === 'false';
}
export function countGridControls(grid) {
    var sum = 0;
    if (grid) {
        for (var _i = 0, _a = grid.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            for (var _b = 0, _c = row.cells; _b < _c.length; _b++) {
                var cell = _c[_b];
                if (cell.controlModel) {
                    sum += 1;
                }
                else if (cell.grid) {
                    sum += countGridControls(cell.grid);
                }
            }
        }
    }
    return sum;
}
export function getContextEntity(layout) {
    switch (layout.dynamicLayoutType()) {
        case DynamicLayoutType.form:
        case DynamicLayoutType.workflowForm:
            return 'entity';
        case DynamicLayoutType.subForm:
            return 'item';
        default:
            return undefined;
    }
}
export function isControlApplicableToFields(metaFieldIds, fieldSet, displayFieldNames) {
    if (!metaFieldIds) {
        return false;
    }
    return (metaFieldIds.find(function (metaFieldId) {
        return fieldSet.some(function (field) {
            return !isNil(field) &&
                metaFieldId.getSystemName() === field.getSystemName() &&
                metaFieldId.getMetaCategoryId().getSystemName() ===
                    field
                        .getMetaFieldId()
                        .getMetaCategoryId()
                        .getSystemName();
        }) &&
            (!displayFieldNames ||
                displayFieldNames.length === 0 ||
                displayFieldNames.some(function (fieldName) {
                    return fieldName === metaFieldId.getSystemName();
                }));
    }) !== undefined);
}
export function getDisplayFieldsNames(validation) {
    if (validation.getValidationDisplay() &&
        validation.getValidationDisplay().getFields() &&
        validation.getValidationDisplay().getDisplayType() ===
            ValidationDisplayType.FIELDS) {
        var fields = validation
            .getValidationDisplay()
            .getFields()
            .get('fields');
        if (!fields) {
            return [];
        }
        return Array.isArray(fields) ? fields : fields.fields || [];
    }
    return [];
}
export function createLogger(scope) {
    return new Logger('idm-dynamic-forms-ui', scope);
}
//# sourceMappingURL=utilities.js.map